"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButtonIconOnly = void 0;

var _styledTools = require("styled-tools");

var _stylitas = require("@creditas/stylitas");

const noShadow = (0, _stylitas.css)`
  &:hover {
    box-shadow: none;
  }
`;

const baseStyles = props => (0, _stylitas.css)`
  border: none;
  outline: none;
  cursor: pointer;
  background-color: ${(0, _styledTools.prop)('theme.colorButtonPrimaryLight')(props)};
  transition: box-shadow 0.3s;

  &:hover {
    box-shadow: 0px 16px 8px -12px rgba(0, 0, 0, 0.12),
      0px 16px 12px -8px rgba(0, 0, 0, 0.16);
  }

  &:disabled {
    background-color: ${(0, _styledTools.prop)('theme.colorNeutral10')(props)};
  }

  ${(0, _styledTools.ifProp)('disabled', noShadow)(props)}
`;

const size = (0, _styledTools.switchProp)('size', {
  medium: (0, _stylitas.css)`
    width: 44px;
    height: 44px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  large: (0, _stylitas.css)`
    width: 60px;
    height: 60px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    & > svg {
      width: 32px;
      height: 32px;
    }
  `
});
const StyledButtonIconOnly = _stylitas.styled.button`
  ${baseStyles}
  ${size}
`;
exports.StyledButtonIconOnly = StyledButtonIconOnly;